import { render, staticRenderFns } from "./FailedPaymentAlert.vue?vue&type=template&id=135a390f"
import script from "./FailedPaymentAlert.vue?vue&type=script&lang=js"
export * from "./FailedPaymentAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports